// src/data/gyms/Legend.js
export const Legend = {
  id: "legend",
  name: "Legend Athletics",
  color: "#9333EA", // Legendary Purple
  lightColor: "#F3E8FF",
  logo: "🏆",

  teams: [
    {
      id: "cosmiccrew",
      name: "Cosmic Crew",
      level: "L1.1 Youth - PREP",
    },
    {
      id: "sweethearts",
      name: "Sweethearts",
      level: "L1 Tiny - Novice",
    },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "9:06 AM", // Floor compete
      teamId: "cosmiccrew",
      meet: "8:30 AM", // Check-in
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "9:10 AM",
      teamId: "sweethearts",
      meet: "8:34 AM",
      panel: "Hall A",
    },

    // ================= SUNDAY (Dec 14) =================
    // No Sunday performances listed for these Prep/Novice teams.
  ],
};
